/**
 * Hands-free voice navigation preference.
 *
 * Persisted toggle that mirrors the input-mode preference pattern in
 * EpisodePage.tsx (selna_game_input_mode). When ON, the between-conversation
 * screens (episode-ready, waiting/recap) read text aloud and listen for voice
 * commands, and the conversation itself defaults to voice/VAD input.
 */

const HANDS_FREE_STORAGE_KEY = 'selna_game_hands_free';

export function getHandsFree(): boolean {
  try {
    return localStorage.getItem(HANDS_FREE_STORAGE_KEY) === '1';
  } catch {
    // localStorage unavailable (e.g. private browsing)
    return false;
  }
}

export function setHandsFree(enabled: boolean): void {
  try {
    localStorage.setItem(HANDS_FREE_STORAGE_KEY, enabled ? '1' : '0');
  } catch {
    // localStorage unavailable
  }
}
